import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { analytics } from '@/shared/lib/analytics';

/**
 * Counts every page shown, if the visitor agreed (shared/lib/analytics). Inside the
 * router, where the address is known: not by subscribing to the router from outside it,
 * which held up its first navigation to a page loaded on demand.
 */
export function PageViews() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    analytics.page();
  }, [pathname, search]);
  return null;
}
